import { Box, Chip, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

import type { GuestAsk } from "@thalamos/haven-common";

// The end of a UK calendar day, so it is shown as a UK date wherever the
// browser is.
const UK_CALENDAR_DATE = new Intl.DateTimeFormat("en-GB", {
  dateStyle: "long",
  timeZone: "Europe/London",
});

/** The mark an assessment a guest owns carries in a list. */
export const GuestChip = () => {
  const { t } = useTranslation();

  return (
    <Chip
      size="small"
      variant="outlined"
      label={t("personPage.assessments.guest")}
    />
  );
};

/**
 * A guest named as an assessment's assessor, with who asked them and, while
 * the assessment is with them, the day their access ends.
 */
export const GuestAssessor = ({
  name,
  guestAsk,
  withGuest,
}: {
  name: string;
  guestAsk: GuestAsk;
  /** Whether the guest is still completing it. */
  withGuest: boolean;
}) => {
  const { t } = useTranslation();

  return (
    // Spans throughout, so it sits inside a line of text as well as a cell.
    <Box
      component="span"
      sx={{ display: "inline-flex", flexDirection: "column" }}
    >
      <span>{name}</span>
      <Typography component="span" variant="caption" color="text.secondary">
        {t("personPage.assessments.askedBy", { asker: guestAsk.askerName })}
      </Typography>
      {withGuest && guestAsk.endsAt !== null ? (
        <Typography component="span" variant="caption" color="text.secondary">
          {t("personPage.assessments.guestUntil", {
            date: UK_CALENDAR_DATE.format(guestAsk.endsAt),
          })}
        </Typography>
      ) : null}
    </Box>
  );
};
